module.exports = __webpack_public_path__ + "static/media/icon-truck-reclaim-cancelled.ed5b3b70.png";